import React from 'react';
import {
  BreadcrumbsPageName,
  CategoryTitleWrapper,
  PageHeaderSectionWrapper,
} from './styles';
import { Flex, Text, ThemeMode, useThemeMode } from '@amzn/storm-ui';
import { connect } from 'react-redux';
import {
  SelectedToolbarItem,
  selectLandingAppName,
  selectRenderTagInPageName,
  selectSelectedToolbarItem,
  updateLandingAppName,
} from 'src/features/nav/store/slice';
import { RootState } from 'src/app/store';
import { useBreadcrumbTruncationContext } from '../BreadcrumbIA2/BreadcrumbTruncationContext';
import {
  LANDING_PLACEMENT,
  LandingAppIcon,
} from 'src/commons/components/LandingAppIcon/LandingAppIcon';
import { selectIsSpoofing } from '../../store/slice';
import { Flag } from 'src/app/slice';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { useLinkUpdater } from 'src/commons/utils/linkUpdater';

interface AppNameSectionProps {
  chromeConfigAppName: string;
  selectedToolbarItem: SelectedToolbarItem | undefined;
  isMobile?: boolean;
  pageTitleFlag: Flag | null;
  landingAppName: string;
  isSpoofing: boolean;
  updateLandingAppName: (...args: any[]) => any;
}

export const AppNameSection: React.FC<AppNameSectionProps> = ({
  chromeConfigAppName,
  selectedToolbarItem,
  isMobile = false,
  pageTitleFlag,
  landingAppName,
  isSpoofing,
  updateLandingAppName,
}) => {
  const { themeMode } = useThemeMode();
  const { pageTitleRef } = useBreadcrumbTruncationContext();
  const transformUrl = useLinkUpdater();

  let url,
    category,
    appKeyName,
    selectedAppName,
    shouldDisplayCategory,
    isInternal;
  let shouldRenderCategory;

  if (selectedToolbarItem) {
    ({
      url,
      category,
      appName: selectedAppName,
      appKeyName,
      shouldDisplayCategory,
      isInternal,
    } = selectedToolbarItem);
    shouldRenderCategory = shouldDisplayCategory && !isMobile;
  } else {
    url = window.location.href;
    shouldRenderCategory = false;
  }
  const resolvedUrl = url && transformUrl ? transformUrl(url) : url;
  const appName = selectedAppName ?? chromeConfigAppName;
  let ariaLabel = `${appName}.`;
  ariaLabel = shouldRenderCategory ? `${category}: ${ariaLabel}` : ariaLabel;
  ariaLabel = pageTitleFlag?.type
    ? `${ariaLabel} ${pageTitleFlag.type}`
    : ariaLabel;
  const shouldShowLandingIcon = !isSpoofing && !isInternal && !!appKeyName;

  return (
    <Flex alignItems="center">
      <PageHeaderSectionWrapper
        aria-label={ariaLabel}
        href={resolvedUrl}
        anchorRef={pageTitleRef}
        {...getTaktAttributes('page-title', chromeComponents.HEADER, {
          url: resolvedUrl,
        })}
      >
        <CategoryTitleWrapper>
          <BreadcrumbsPageName
            renderAs="span"
            color={themeMode === ThemeMode.DARK ? 'default' : 'inverted'}
            size="base"
            weight="bold"
            data-ccx-e2e-id="aac-page-title"
          >
            {shouldRenderCategory && (
              <Text
                size="small"
                weight="regular"
                color={themeMode === ThemeMode.DARK ? 'default' : 'inverted'}
              >
                {category}
              </Text>
            )}
            {appName}
            {pageTitleFlag && (
              <LaunchFlag
                flag={{
                  ...pageTitleFlag,
                  isInverted: true,
                  isMobile: isMobile,
                }}
              />
            )}
          </BreadcrumbsPageName>
        </CategoryTitleWrapper>
      </PageHeaderSectionWrapper>
      {shouldShowLandingIcon && (
        <LandingAppIcon
          appName={appKeyName}
          landingAppName={landingAppName}
          tooltipLabel={appName}
          landingPlacement={LANDING_PLACEMENT.HEADER}
          updateLandingAppName={updateLandingAppName}
        />
      )}
    </Flex>
  );
};

const connector = connect(
  (state: RootState) => {
    return {
      selectedToolbarItem: selectSelectedToolbarItem(state),
      pageTitleFlag: selectRenderTagInPageName(state),
      landingAppName: selectLandingAppName(state),
      isSpoofing: selectIsSpoofing(state),
    };
  },
  (dispatch) => {
    return {
      updateLandingAppName: (category) =>
        dispatch(updateLandingAppName(category)),
    };
  },
);

export const ConnectedAppNameSection = connector(AppNameSection);
